import type { QueryClient } from '@tanstack/react-query';
import { AuditQueryKeys } from '../api/keys';
import {
  type AuditPatch,
  type CacheSnapshot,
  cancelAuditQueries,
  snapshotAndPatchAudit,
  rollbackAuditCache,
} from './patchAuditCache';

/**
 * Cancels in-flight audit-detail queries for a specific auditId.
 * Called before optimistic updates to prevent race conditions.
 */
export async function cancelAuditDetailQueries(
  queryClient: QueryClient,
  auditId: string,
): Promise<void> {
  await cancelAuditQueries(queryClient, AuditQueryKeys.details, auditId);
}

/**
 * Snapshots current cache state and optimistically patches audit-detail
 * queries for a given auditId. Returns snapshots for rollback on error.
 */
export function snapshotAndPatchAuditDetail(
  queryClient: QueryClient,
  auditId: string,
  patch: AuditPatch,
): CacheSnapshot[] {
  return snapshotAndPatchAudit(queryClient, AuditQueryKeys.details, auditId, patch);
}

/**
 * Rolls back cached audit-detail queries to their previous state.
 */
export function rollbackAuditDetailCache(
  queryClient: QueryClient,
  snapshots: CacheSnapshot[],
): void {
  rollbackAuditCache(queryClient, snapshots);
}
